import type { QueryClient } from "@tanstack/react-query";
import { QueryKeys } from "@/lib/types";
import { fetchStudioFeatureSettings } from "@/lib/utils/feature-settings/feature-settings-api";
import { fetchMakeupsEligibilitySettings } from "@/lib/utils/makeup-settings/makeup-settings-api";
import { fetchStudioSignalsSettings } from "@/lib/utils/signals-settings/signals-settings-api";

const MEMBER_DASHBOARD_SETTINGS_STALE_TIME_MS = 60_000;

/** Sidebar + module gates on every dashboard route. */
export async function prefetchStudioFeatureSettings(
  tenantId: number,
  queryClient: QueryClient,
  accessToken: string,
) {
  if (!tenantId) return queryClient;

  await queryClient.prefetchQuery({
    queryKey: [QueryKeys.StudioFeatureSettings, tenantId],
    queryFn: () => fetchStudioFeatureSettings(tenantId, { accessToken }),
    staleTime: MEMBER_DASHBOARD_SETTINGS_STALE_TIME_MS,
  });

  return queryClient;
}

/** SSR prefetch for member home today-signals + makeup eligibility widgets. */
export async function prefetchMemberDashboardMemberSettings(
  tenantId: number,
  queryClient: QueryClient,
  accessToken: string,
) {
  if (!tenantId) return queryClient;

  await Promise.all([
    prefetchStudioFeatureSettings(tenantId, queryClient, accessToken),
    queryClient.prefetchQuery({
      queryKey: [QueryKeys.StudioSignalsSettings, tenantId],
      queryFn: () => fetchStudioSignalsSettings(tenantId, { accessToken }),
      staleTime: MEMBER_DASHBOARD_SETTINGS_STALE_TIME_MS,
    }),
    queryClient.prefetchQuery({
      queryKey: [QueryKeys.MakeupEligibilitySettings, tenantId],
      queryFn: () => fetchMakeupsEligibilitySettings(tenantId, { accessToken }),
      staleTime: MEMBER_DASHBOARD_SETTINGS_STALE_TIME_MS,
    }),
  ]);

  return queryClient;
}
